import ShowCase from '../views/ShowCase'

export default ShowCase